'use client';

import { css } from '@repo/pandacss/styled-system/css';
import { Details } from '@repo/ui-v2/Details';
import { useState } from 'react';
import { MdExpandMore as ExpandMoreIcon } from 'react-icons/md';

export function MoreAuthorsAccordion({
  numberOfAdditionalAuthors,
}: {
  numberOfAdditionalAuthors: number;
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (numberOfAdditionalAuthors === 0) {
    return null;
  }

  return (
    <Details
      variant="simple"
      detailsProps={{
        onToggle: ({ newState }) => setIsExpanded(newState === 'open'),
      }}
      SummaryComponent={
        <>
          <span
            className={css({
              fontWeight: 'medium',
              textStyle: 'notesSmall',
            })}
          >{`+ ${numberOfAdditionalAuthors} more`}</span>
          <ExpandMoreIcon className="expand-icon" />
        </>
      }
      summaryComponentProps={{
        'data-testid': 'mobile-author-byline-summary',
        'aria-controls': 'mobile-author-byline-extra-authors',
        'aria-expanded': isExpanded,
        id: 'mobile-author-byline-summary',
        className: css({
          marginLeft: '2',
          width: 'fit',
          height: 'fit',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          _hover: {
            outlineWidth: 'thin',
            outlineStyle: 'solid',
            outlineColor: 'lime.tintLP2',
            outlineOffset: '[4px]',
          },
          '& .expand-icon': {
            fontSize: 'lg',
            color: 'white',
          },
        }),
      }}
    />
  );
}
